module.exports = __webpack_public_path__ + "static/media/video-call-small.51877b92.png";